import { render, staticRenderFns } from "./leftBottom.vue?vue&type=template&id=0b9102b3&scoped=true&"
import script from "./leftBottom.vue?vue&type=script&lang=js&"
export * from "./leftBottom.vue?vue&type=script&lang=js&"
import style0 from "./leftBottom.vue?vue&type=style&index=0&id=0b9102b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9102b3",
  null
  
)

export default component.exports